<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { LMS_PROVIDERS, PLATFORMS } from "@/constants";
import egLogoTransparent from "@/assets/eg-logo-tiny-transparent.png";

const SOURCE_MATERIALS_PLATFORMS = {
  [PLATFORMS.ESSAYGRADER]: {
    label: "EssayGrader",
    icon: egLogoTransparent,
    key: "essaygrader",
  },
  [PLATFORMS.GOOGLE]: LMS_PROVIDERS.google,
  [PLATFORMS.CANVAS]: LMS_PROVIDERS.canvas,
};

export default {
  name: "MaterialsPlatformsProvider",
  provide() {
    return {
      materialPlatforms: this.materialPlatforms,
    };
  },
  inject: ["growthBook"],
  computed: {
    materialPlatforms() {
      const currentEmail = this.growthBook?.attributes?.email;
      const value = this.growthBook?.getFeatureValue("schoology-enabled");
      const isSchoologyFeatureEnabled =
        value === true ||
        (Array.isArray(value) && value.includes(currentEmail));
      if (isSchoologyFeatureEnabled) {
        return {
          ...SOURCE_MATERIALS_PLATFORMS,
          [PLATFORMS.SCHOOLOGY]: LMS_PROVIDERS.schoology,
        };
      }

      return SOURCE_MATERIALS_PLATFORMS;
    },
  },
};
</script>
